import React from 'react';
import { SettingsIcon, RocketIcon, PenToolIcon, LineChartIcon } from 'lucide-react';
export function CurriculumSection() {
  const modules = [{
    number: 1,
    title: 'Fundamentos y configuración',
    subtitle: 'De cero a tu casa digital en orden',
    icon: SettingsIcon,
    highlights: ['Business Manager paso a paso', 'Conectar Facebook e Instagram', 'Instalar el píxel sin volverte loco'],
    result: 'Ecosistema listo para hacer publicidad sin miedo'
  }, {
    number: 2,
    title: 'Tus primeras campañas',
    subtitle: 'De "no tengo idea" a "ya lancé"',
    icon: RocketIcon,
    highlights: ['Objetivos explicados para humanos', 'Elegir público y presupuesto', 'Lanzar sin tocar cosas innecesarias'],
    result: 'Al menos una campaña lanzada con seguridad'
  }, {
    number: 3,
    title: 'Creativos y textos con IA',
    subtitle: 'No eres diseñador ni copy… y no hace falta',
    icon: PenToolIcon,
    highlights: ['Estructura simple de anuncio efectivo', 'IA para textos y versiones alternativas', 'Conectar con WhatsApp o landing'],
    result: 'Anuncios claros sin bloquearte en diseño'
  }, {
    number: 4,
    title: 'Interpretar los números',
    subtitle: 'Lo mínimo para no ir a ciegas',
    icon: LineChartIcon,
    highlights: ['Métricas clave: CTR, CPM, CPC', 'Qué significan en palabras simples', 'Cambios básicos sin romper todo'],
    result: 'Leer campañas sin entrar en pánico'
  }];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-175">
      <div className="max-w-6xl mx-auto px-6" data-id="element-176">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-177">
          Lo que vas a aprender, paso a paso
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-178">
          4 módulos prácticos diseñados para principiantes
        </p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-179">
          {modules.map(module => {
          const Icon = module.icon;
          return <div key={module.number} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 overflow-hidden hover:border-[#0866FF]/30 transition-colors duration-300" data-id="element-180">
                {/* Header */}
                <div className="bg-[#0866FF] p-6" data-id="element-181">
                  <div className="flex items-center gap-3 mb-2" data-id="element-182">
                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center" data-id="element-183">
                      <Icon className="w-5 h-5 text-white" data-id="element-184" />
                    </div>
                    <span className="text-blue-200 text-sm font-medium" data-id="element-185">
                      Módulo {module.number}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-186">
                    {module.title}
                  </h3>
                  <p className="text-blue-100 text-sm italic" data-id="element-187">
                    {module.subtitle}
                  </p>
                </div>

                {/* Content */}
                <div className="p-6" data-id="element-188">
                  <ul className="space-y-2 mb-4" data-id="element-189">
                    {module.highlights.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-gray-700" data-id="element-190">
                        <span className="text-[#0866FF] font-bold mt-0.5" data-id="element-191">
                          ✓
                        </span>
                        <span className="text-sm" data-id="element-192">{item}</span>
                      </li>)}
                  </ul>
                  <div className="bg-green-50 rounded-lg p-3 border-l-4 border-green-500" data-id="element-193">
                    <p className="text-green-800 text-sm font-medium" data-id="element-194">
                      {module.result}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}